<script lang="ts">

  import { browser } from "$app/environment"
  import { Button } from "$lib/components/ui/button"
  import XIcon from "@lucide/svelte/icons/x"

</script>

<main class="overflow-auto relative mx-auto h-full max-w-3xl">
  <nav class="sticky w-full top-0 inset-s-0 inset-e-0 z-10 bg-background border-b max-w-3xl">
    <div class="flex h-12 items-center justify-between px-3">
      <div class="flex items-center">
        <Button
          variant="ghost"
          size="icon"
          class="me-2 rounded-full"
          aria-label="Tutup"
          onclick={() => browser && window.history.back()}>
          <XIcon/>
        </Button>
        <h1 class="text-lg font-medium">Manual</h1>
      </div>
      <div></div>
    </div>
  </nav>
  <div class="flex h-full items-center justify-center">Sedang dalam pengembangan</div>
</main>
